import { render, staticRenderFns } from "./headNav.vue?vue&type=template&id=68b2a7b9&scoped=true&"
import script from "./headNav.vue?vue&type=script&lang=js&"
export * from "./headNav.vue?vue&type=script&lang=js&"
import style0 from "./headNav.vue?vue&type=style&index=0&id=68b2a7b9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b2a7b9",
  null
  
)

export default component.exports